module.exports = __webpack_public_path__ + "static/media/DURBAN_JULY.b2b0bb96.png";